module.exports = __webpack_public_path__ + "img/prize-sm-dark.daaf4f2b.png";